<template>
  <div class="weui-cell weui-cell_access" @click="select">
    <div class="weui-cell__hd">
      <label for class="weui-label">{{label}}</label>
    </div>
    <div class="weui-cell__bd" v-format="format">{{value}}</div>
    <div class="weui-cell__ft">
      <span v-show="!value">请选择</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    format: {
      type: String,
      default: "yyyy-MM-dd hh:mm"
    },
    value: String
  },
  methods: {
    select() {
      var me = this,
        date = me.value ? new Date(me.value.replace(/-/g, '/')) : new Date(),
        year = date.getFullYear(),
        years = [],
        month = date.getMonth() + 1,
        months = [],
        day = date.getDate(),
        days = [],
        hour = date.getHours(),
        hours = [],
        minute = date.getMinutes(),
        minutes = [],
        i,
        len;
      for (i = year - 20, len = year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      for (i = 1, len = 12; i <= len; i++) {
        months.push({
          value: i,
          label: i + "月"
        });
      }
      for (i = 1, len = 31; i <= len; i++) {
        days.push({
          value: i,
          label: i + "日"
        });
      }
      for (i = 0, len = 23; i <= len; i++) {
        hours.push({
          value: i,
          label: i + "时"
        });
      }
      for (i = 0, len = 3; i <= len; i++) {
        minutes.push({
          value: i * 15,
          label: i * 15 + "分"
        });
      }

      me.$weui.picker(years, months, days, hours, minutes, {
        defaultValue: [year, month, day, hour, minute],
        onChange: function(r) {
          var content = document.getElementsByClassName("weui-picker__group")[2]
              .children[2],
            nodes = content.children,
            maxDate = new Date(r[0].value, r[1].value, 1, 0, 0, -1).getDate();
          for (var i = 31; i > 28; i--) {
            if (i > maxDate) {
              nodes[i - 1].style.display = "none";
            } else {
              nodes[i - 1].removeAttribute("style");
            }
          }
          if (r[2] > maxDate) {
            r[2] = {
              value: maxDate,
              label: maxDate + "日"
            };
            var diff = (3 - maxDate) * 48;
            content.style.transform = `translate3d(0, ${diff}px, 0)`;
            content.style.webkitTransform = `translate3d(0, ${diff}px, 0)`;
          }
        },
        onConfirm: function(r) {
          var date = new Date(
              r[0].value,
              r[1].value - 1,
              r[2].value,
              r[3].value,
              r[4].value
            ),
            val = me.dateFormat(date, "yyyy-MM-dd hh:mm:ss");
          me.$emit("input", val);
          me.$emit("selected")
        }
      });
    }
  }
};
</script>